(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/widget-area/assets/javascripts/widget-area.js') >= 0) return;  svs.modules.push('/components/core/widget-area/assets/javascripts/widget-area.js'); "use strict";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

svs = svs || {};

(function (svs, $) {
  'use strict';

  svs.core = svs.core || {};
  svs.widget = svs.widget || {};
  svs.core.widget_area = svs.core.widget_area || {};
  svs.core.widget_area.logger = new svs.core.log.Logger('core:widget-area'); 

  const widgetFiltering = {};

  function initWidget(area, index, widget, widgetData) {
    let $el;
    let data;
    let $area; 

    if (!area) {
      svs.core.widget_area.logger.warn('No area supplied');
      return;
    }

    if (!widget) {
      svs.core.widget_area.logger.warn('No widget supplied');
      return;
    } 


    $el = $("#".concat(area, " > .widget"));

    if (!widget.templates) {
      widget.init(widgetData);
    } else if (Boolean($el.get(index)) && $($el.get(index)).children().length > 0) {
      data = {};
      data.$el = $($el.get(index)).children();
      data.model = widgetData;
      widget.init(data);
    } else {
      try {
        $area = $("#".concat(area));

        if ($area.length > 0) {
          $area.on('widgetAttached', () => {
            data = {};
            $el = $("#".concat(area, " .widget"));
            data.$el = $($el.get(index)).children();
            data.model = widgetData;
            widget.init(data);
          });
        }
      } catch (e) {
        svs.core.widget_area.logger.error("Error initializing widget: ".concat(e.message), area);
      }
    }
  }


  function findWidget(obj, area) {
    Object.keys(obj).forEach(key => {
      if (typeof obj[key].forEach === 'function' && (!area || area === key)) {
        const widgets = obj[key];
        widgets.forEach((widget, index) => {
          if (widget.widget) {
            if (svs.widget[widget.widget]) {
              if (typeof svs.widget[widget.widget].init === 'function') {
                initWidget(key, index, svs.widget[widget.widget], widget.data);
              } else if (widgetFiltering[widget.widget]) {
                widgetFiltering[widget.widget] = true;
                svs.core.widget_area.logger.debug("No init function found for widget: ".concat(widget.widget));
              }
            }
          }
        });
      }
    });
  }


  function init(area) {
    if (svs.widgets && svs.widgets.data) {
      findWidget(svs.widgets.data, area);
    }
  }


  function loadArea(area, className, finalCallback) {
    if (finalCallback === undefined) {
      finalCallback = className;
      className = undefined;
    }

    const widgets = svs.widgets.data[area];

    if (widgets) {
      const widgetsToLoad = widgets 
      .filter(widget => widget.data && widget.data.fetchDataUrl) 
      .map(widget => {
        const d = $.Deferred();
        const widgetName = widget.widget;
        const widgetComponent = svs.widget[widgetName];

        if (widgetComponent && widgetComponent.fetchData) {
          const _widget$data = widget.data,
                {
            fetchDataUrl: url
          } = _widget$data,
                data = _objectWithoutProperties(_widget$data, ["fetchDataUrl"]);

          widgetComponent.fetchData({
            area,
            url
          }, data, (err, completeData) => {
            if (completeData) {
              widget.data = completeData;
              widget.partial = "widget-".concat(widgetName, "-").concat(Object.keys(widgetComponent.templates)[0]);
            }

            d.resolve();
          });
        } else {
          d.resolve();
        }

        return d;
      }); 

      $.when.apply(this, widgetsToLoad).then(() => {
        const templateString = Handlebars.helpers.widgetArea({
          hash: {
            name: area,
            class: className
          }
        });
        finalCallback(templateString);
      }, () => {
        finalCallback(); 
      });
    } else {
      finalCallback();
    }
  } 


  svs.core.widget_area.init = init;
  svs.core.widget_area.loadArea = loadArea; 

  $(() => init());
})(svs, $);
 })(window);